import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import PartnerIntegration from '../../components/User/Company/PartnerIntegration'
import PartnerPrograms from '../../components/User/Company/PartnerPrograms'

const Partners = () => {
  return (
    <div>
        <SimpleBanner title='Our Partners' subheading='Home > Company > Partner' />
        <PartnerIntegration/>
        <PartnerPrograms/>
    </div>
  )
}

export default Partners